/*
 * @Description:
 * @Date: 2024-12-12 11:54:05
 */
import ContractRedirect from '../views/contract-redirect.vue';

export const route = [
  {
    path: '/contract/contract-redirect',
    component: ContractRedirect,
    meta: {
      title: '合同签署'
    }
  }
];
